import { TelefoneUsuario } from '../comum/modelos/telefone-usuario';
import { EnderecoUsuario } from '../comum/modelos/endereco-usuario';
import { SettingsService } from './../settings.service';
import { Usuario } from '../comum/modelos/usuario';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class UsuarioService {

  private _host: string;

  constructor(private _settingsService: SettingsService,
    private _http: HttpClient) {
    this._host = this._settingsService.obterHostBase() + '/usuarios/';
  }

  obterUsuariosHttp(id: number): Observable<Usuario[]> {
    return this._http.get(this._host + 'cliente/' + id)
      .catch(this.handleError);
  }

  obterUsuarioPorIdHttp(id: number): Observable<Usuario> {
    return this._http.get(this._host + id)
      .catch(this.handleError);
  }

  obterUsuarioPorUidHttp(uid: string): Observable<Usuario> {
    return this._http.get(this._host + 'uid/' + uid)
      .catch(this.handleError);
  }

  cadastrarUsuarioHttp(usuario: Usuario, foto: File): Observable<HttpResponse<Usuario>> {
    const formdata: FormData = new FormData();
    formdata.append('imagem', foto);
    formdata.append('usuario', new Blob([JSON.stringify(usuario)], {
      type: 'application/json'
    }));
    return this._http
      .post(this._host, formdata, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarUsuarioHttp(usuario: Usuario, foto: File): Observable<HttpResponse<Usuario>> {
    const formdata: FormData = new FormData();
    formdata.append('imagem', foto);
    formdata.append('usuario', new Blob([JSON.stringify(usuario)], {
      type: 'application/json'
    }));
    return this._http
      .put(this._host, formdata, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerUsuarioHttp(idUsuario: number): Observable<HttpResponse<Usuario>> {
    return this._http.delete(this._host + idUsuario, {
      observe: 'response'
    })
      .catch(this.handleError);
  }

  cadastrarTelefonesUsuarioHttp(telefoneUsuario: TelefoneUsuario[]): Observable<HttpResponse<TelefoneUsuario[]>> {
    return this._http
      .post(this._host + 'telefone-usuario/', telefoneUsuario, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarTelefonesUsuarioHttp(telefoneUsuario: TelefoneUsuario[]): Observable<HttpResponse<TelefoneUsuario[]>> {
    return this._http
      .put(this._host + 'telefone-usuario/', telefoneUsuario, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerTelefonesUsuarioHttp(telefoneUsuario: TelefoneUsuario[]): Observable<HttpResponse<TelefoneUsuario[]>> {
    return this._http
      .patch(this._host + 'telefone-usuario/', telefoneUsuario, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  cadastrarEnderecosUsuarioHttp(enderecoUsuario: EnderecoUsuario[]): Observable<HttpResponse<EnderecoUsuario[]>> {
    return this._http
      .post(this._host + 'endereco-usuario/', enderecoUsuario, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarEnderecosUsuarioHttp(enderecoUsuario: EnderecoUsuario[]): Observable<HttpResponse<EnderecoUsuario[]>> {
    return this._http
      .put(this._host + 'endereco-usuario/', enderecoUsuario, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerEnderecosUsuarioHttp(enderecoUsuario: EnderecoUsuario[]): Observable<HttpResponse<EnderecoUsuario[]>> {
    return this._http
      .patch(this._host + 'endereco-usuario/', enderecoUsuario, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  buscarUsuariosFuncionalidadeHttp(idCliente: number, nomeFuncionalidade: string, idUsuario: number): Observable<Usuario[]> {
    return this._http.get(this._host + 'funcionalidade' + '?idCliente='
      + idCliente + '&nomeFuncionalidade=' + nomeFuncionalidade + '&idUsuario=' + idUsuario)
      .catch(this.handleError);
  }

  buscarUsuariosGrupoAcessoHttp(idCliente: number, idGrupoAcesso: number): Observable<Usuario[]> {
    return this._http.get(this._host + 'grupo-acesso' + '?idCliente='
      + idCliente + '&idGrupoAcesso=' + idGrupoAcesso)
      .catch(this.handleError);
  }

  private handleError(error: Response) {

    console.error(error);

    return Observable.throw(error.json().error || 'Server error');

  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/usuario/usuario.service.ts